// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import UI from './ui/UI'
import Chart from './components/Chart'
import Nav from './components/AppNav'
import Practice from './components/Practice'
import {
  ThemeProvider
} from 'vue-styled-components'
import VModal from 'vue-js-modal'


// TODO rename battles-api
import {
  getNextStep,
  getCompletions
} from './utils/battles-api'
import {
  completeStep
} from './utils/battles-api'
import {
  previousStep
} from './utils/battles-api'
import {
  setChain
} from './utils/battles-api'
import {
  setPreference
} from './utils/battles-api'


// Vue.use(Vuefire)
// TODO: no need for Vueresource and Axios ?
// Vue.use(Vueresource)
Vue.use(VModal, {
  dynamic: true,
  adaptive: true,
  dynamicDefaults: {
    clickToClose: false
  }
})
Vue.use(Vuex)
Vue.config.productionTip = false

// Component Definitions

Vue.component('LessonCTA', UI.components.LessonCTA)
Vue.component('LessonCard', UI.components.LessonCard)
Vue.component('ContentFrame', UI.components.ContentFrame)
Vue.component('CenterWrapper', UI.components.CenterWrapper)
Vue.component('PageTitle', UI.components.PageTitle)

Vue.component('QuestionTitle', UI.components.QuestionTitle)
Vue.component('QuestionWrapper', UI.components.QuestionWrapper)
Vue.component('ChoicesWrapper', UI.components.ChoicesWrapper)
Vue.component('Choice', UI.components.Choice)
Vue.component('ChoiceTitle', UI.components.ChoiceTitle)
Vue.component('ChoiceBlurb', UI.components.ChoiceBlurb)
Vue.component('ChoiceContext', UI.components.ChoiceContext)
Vue.component('ChoiceConfirm', UI.components.ChoiceConfirm)

// junk
Vue.component('selectable', UI.components.selectable)
Vue.component('box', UI.components.box)
Vue.component('cta', UI.components.cta)


// chart
Vue.component('practice', Practice)
Vue.component('chart', Chart)
Vue.component('BurgerNav', Nav)
Vue.component('theme-provider', ThemeProvider)

const store = new Vuex.Store({
  state: {
    step: {},
    // TODO This should be moved into user object
    preference: {
      lookingFor: '',
      practiceTime: '',
      goal: ''
    },
    user: {},
    completions: [],
    completionStepForModal: null,
  },
  getters: {

    // TODO sort of a hack, best if this is in some central location
    // steps and validation
    onboardingNextDisabled: (state) => (step) => {
      if (step == 0 && state.preference.lookingFor != '')  {
        return false
      }

      if (step == 1 && state.preference.practiceTime !== '') {
        return false
      }

      if (step == 2 && state.preference.goal !== '') {
        return false
      }

      return true
    }
  },
  mutations: {
    setCompletionStepForModal(state, step) {
      state.completionStepForModal = step
    },
    setUser(state, user) {
      // console.log("setting user", user)
      state.user = user
    },
    getNextStep(state) {
      getNextStep().then((step) => {
        state.step = step
      })
    },
    getCompletions(state) {
      getCompletions().then((completions) => {
        state.completions = completions
      })
    },
    completeStep(state, step) {
      completeStep(step).then((step) => {
        state.step = step
      })
    },
    previousStep(state, step) {
      previousStep(step).then((step) => {
        state.step = step
      })
    },
    setChain(state, decision) {
      setChain(decision).then((step) => {
        state.step = step
      })
    },

    //Onboarding
    setLookingFor(state, questionID) {
      state.preference.lookingFor = questionID
    },
    setPracticeTime(state, questionID) {
      state.preference.practiceTime = questionID
    },
    setGoal(state, questionID) {
      state.preference.goal = questionID
    },

    // save all onboarding prefs
    setPreference(state, choices) {
      setPreference(choices).then((user) => {
        console.log("setting user")

        // If user selected trial, redirect home
        if (JSON.parse(localStorage.isTry) === true) {
          router.push({ path: 'home' })
        } 

        state.user = user
      })
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: {
    App
  },
  computed: Vuex.mapState({
    // arrow functions can make the code very succinct!
    step: state => state.step,

    // passing the string value 'count' is same as `state => state.count`
    stepAlias: 'step',
    //Static global???
    name: name => state.name,

    nameAlias: 'name',

    user: state => state.user,

    preference: state => state.preference,

    nameAlias: 'preference',

  })
})



// WEBPACK FOOTER //
// ./src/main.js